module.exports = __webpack_public_path__ + "img/facebook.ca9f285b.svg";